import deleteicon from "../../assets/svg/Assetmanagemant/delete_forever.svg";
import Groupiconblue from "../../assets/svg/partitioncontent/blueVideoImg.svg";
import { observer } from "mobx-react";
import appStore from "../../Config/Store/appStore";
import { toJS } from "mobx";

const ImageBlock = observer(
  ({
    data,
    index,
    image,
    postertab,
    deletepopup,
    permission,
    // assetSignledata,
  }) => {
    return (
      <div
        style={{
          background:
            image !== ""
              ? `linear-gradient(#0D0D0D, #0D0D0D) padding-box, linear-gradient(to right, rgb(50 50 57 / 55%), rgb(255 251 251), rgb(180 173 173 / 22%)) border-box`
              : `linear-gradient(#0D0D0D, #0D0D0D) padding-box, linear-gradient(to right, #0F3B47, #36D2FF, #0F3B47) border-box`,
          borderRadius: "6px",
          border: "1px solid transparent",
          padding: "5px",
          transition: " all 0.3s ",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = `linear-gradient(#0D0D0D, #0D0D0D) padding-box, linear-gradient(to right, #22BBBE, #7DAD41, #F4B719, #E55824, #B52C80) border-box`;
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background =
            image !== ""
              ? `linear-gradient(#0D0D0D, #0D0D0D) padding-box, linear-gradient(to right, rgb(50 50 57 / 55%), rgb(255 251 251), rgb(180 173 173 / 22%)) border-box`
              : `linear-gradient(#0D0D0D, #0D0D0D) padding-box, linear-gradient(to right, #0F3B47, #36D2FF, #0F3B47) border-box`;
        }}
        className={`block ${
          data?.id === toJS(appStore.assetSignledata)?.id ? "active" : ""
        }`}
        onClick={() => {
          postertab(data);
        }}
      >
        {image === "" ? (
          <div className="img-block ">
            <img src={Groupiconblue} alt="" />
          </div>
        ) : (
          <div className="img-block p-0" style={{ overflow: "hidden" }}>
            <img style={{ width: "100%", height: "auto" }} src={image} alt="" />
          </div>
        )}
        <div className="text-block">
          <label>
            {data?.metadata == null
              ? data.filename
              : data?.metadata?.title == null
              ? data.filename
              : data?.metadata?.title}
          </label>
        </div>
        {permission === "edit" ? (
          <div className="dropdown">
            <button
              onClick={(e) => deletepopup(e, data.id)}
              className="delete-poster "
            >
              <img src={deleteicon} alt="delete" />
            </button>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
);

export default ImageBlock;
